import React, { useEffect } from 'react';
import { Outlet, useLocation, Link } from 'react-router';
import { LAST_TAB_PATH_KEY } from './TabLayout';

function HomeIcon({ active }: { active: boolean }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#6E2726' : '#B0A099'} strokeWidth={active ? 2 : 1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9.5 12 3l9 6.5V21a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1V9.5Z" />
    </svg>
  );
}

function MomsIcon({ active }: { active: boolean }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#6E2726' : '#B0A099'} strokeWidth={active ? 2 : 1.5} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="7" r="4" />
      <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" />
      <circle cx="17" cy="7" r="3" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    </svg>
  );
}

function EventsIcon({ active }: { active: boolean }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#6E2726' : '#B0A099'} strokeWidth={active ? 2 : 1.5} strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  );
}

function ForumIcon({ active }: { active: boolean }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#6E2726' : '#B0A099'} strokeWidth={active ? 2 : 1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2z" />
      <path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1" />
    </svg>
  );
}

function ProfileIcon({ active }: { active: boolean }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#6E2726' : '#B0A099'} strokeWidth={active ? 2 : 1.5} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </svg>
  );
}

const TABS = [
  { path: '/home', label: 'Главная', Icon: HomeIcon },
  { path: '/moms', label: 'Участницы', Icon: MomsIcon },
  { path: '/events', label: 'События', Icon: EventsIcon },
  { path: '/forum', label: 'Форум', Icon: ForumIcon },
  { path: '/my-account', label: 'Профиль', Icon: ProfileIcon },
];

export function TabLayoutV2() {
  const location = useLocation();

  useEffect(() => {
    try {
      sessionStorage.setItem(LAST_TAB_PATH_KEY, location.pathname + location.search);
    } catch { /* ignore */ }
  }, [location.pathname, location.search]);

  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <div style={{ position: 'relative', minHeight: '100dvh', background: '#F7F0EA' }}>
      <Outlet />
      <nav
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 40,
          height: 86,
          paddingBottom: 34,
          background: 'rgba(247,240,234,0.82)',
          backdropFilter: 'saturate(180%) blur(22px)',
          WebkitBackdropFilter: 'saturate(180%) blur(22px)',
          borderTop: '1px solid rgba(221,208,197,.55)',
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
        }}
      >
        {TABS.map(({ path, label, Icon }) => {
          const active = isActive(path);
          return (
            <Link key={path} to={path} aria-label={label} style={{ textDecoration: 'none' }}>
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 12,
                  background: active ? 'rgba(110,39,38,.08)' : 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'background .15s ease',
                }}
              >
                <Icon active={active} />
              </div>
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
